import { type ComponentPropsWithoutRef } from 'react';
import { LoadingSpinner } from '@/shared/components/LoadingSpinner';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { cn } from '@/utils';

/**
 * QuizImage - 퀴즈 카드용 이미지 컴포넌트
 * EditableQuizCard/QuizImage.tsx 및 EditableQuestionImage.tsx와 일치
 * @module QuizImage
 */

/**
 * QuestionImage - 메인 질문 이미지 래퍼 (EditableQuestionImage와 일치)
 * 적절한 크기 조정 및 클릭하여 확대 기능이 있는 퀴즈 질문 이미지에 사용
 */
const QuestionImage = ({
  src,
  alt = 'Question image'
}: {
  src: string;
  alt?: string;
}) => {
  return <div className="group relative mb-2xs flex h-[156px] w-full items-center justify-center rounded-sm border border-opacity-assistive bg-neutral p-sm" data-sentry-component="QuestionImage" data-sentry-source-file="QuizImage.tsx">
      <div className="relative flex items-center justify-center">
        <Container onClick={() => imageDetailModal.open(src)} data-sentry-element="Container" data-sentry-source-file="QuizImage.tsx">
          <Thumbnail className="h-full max-h-[132px] w-full max-w-[578px] object-contain" src={src} alt={alt} data-sentry-element="Thumbnail" data-sentry-source-file="QuizImage.tsx" />
        </Container>
      </div>
    </div>;
};
QuestionImage.displayName = 'QuizQuestionImage';
const Container = (props: ComponentPropsWithoutRef<'div'>) => {
  const {
    className,
    onClick,
    children,
    ...rest
  } = props;
  return <div {...rest} onClick={e => {
    onClick?.(e);
    e.stopPropagation();
  }} className={cn('relative rounded-xs border border-opacity group/image-thumbnail w-fit overflow-hidden flex items-center h-full cursor-pointer', className)} data-sentry-component="Container" data-sentry-source-file="QuizImage.tsx">
      <div className="absolute inset-0 bg-dimmed opacity-0 transition-opacity group-hover/image-thumbnail:opacity-100" />
      {children}
    </div>;
};
Container.displayName = 'QuizImageContainer';
const Thumbnail = (props: ComponentPropsWithoutRef<'img'>) => {
  const {
    className,
    src,
    ...rest
  } = props;
  return <img {...rest} className={cn('w-full h-full object-cover max-h-[132px] max-w-[558px]', className)} src={src} data-sentry-component="Thumbnail" data-sentry-source-file="QuizImage.tsx" />;
};
Thumbnail.displayName = 'QuizImageThumbnail';
const Loading = ({
  className
}: {
  className?: string;
}) => {
  return <div className={cn('flex h-full w-full max-w-[287px] items-center justify-center rounded-xs border border-opacity-assistive bg-dimmed', className)} data-sentry-component="Loading" data-sentry-source-file="QuizImage.tsx">
      <LoadingSpinner className="size-lg text-white" data-sentry-element="LoadingSpinner" data-sentry-source-file="QuizImage.tsx" />
    </div>;
};
Loading.displayName = 'QuizImageLoading';
export const QuizImage = {
  QuestionImage,
  Container,
  Thumbnail,
  Loading
};